export function btnUpToTop() {
    const myButton = document.getElementById('myBtn')

     window.onscroll = function () {
  scrollFunction();
     }
    
    
    function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    myButton.style.display = 'block';
  }      
  else {
    myButton.style.display = 'none';
  }
}
    myButton.addEventListener('click', topFunction)
    
}
 

// When the user clicks on the myButton, scroll to the top of the document
 export function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}


